import Vue from 'vue'
import VueRouter from 'vue-router'
//引入页面
import login from '../views/login/login.vue'
import layout from '../views/layout/layout.vue'
import notFound from '../views/notFound/notFound.vue'
import forget from '../views/page/forget/forget.vue'
// 二级页面
import clinic from '../views/page/clinic/clinic.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'login',
		component: login,
		meta: {
			title: '欢迎登录-河北省司法鉴定委托受理案件管理系统'
		}
	},
	{
		path: '/layout',
		name: 'layout',
		component: layout,
		redirect: '/clinic',
		children: [{
			path: '/clinic',
			name: 'clinic',
			component: clinic,
			meta: {
				title: '河北省司法鉴定委托受理案件管理系统-鉴定案件列表'
			}
		}, {
			path: '/forget',
			name: 'forget',
			component: forget,
			meta: {
				title: '河北省司法鉴定委托受理案件管理系统-修改密码'
			}
		}]
	},
	{
		path: '/notFound',
		name: 'notFound',
		component: notFound,
		meta: {
			title: '河北省司法鉴定委托受理案件管理系统-页面不存在'
		}
	},
	{
		path: '*',
		redirect: '/notFound'
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router
